$('.venobox').venobox({
  overlayColor: 'rgba(255, 255, 255, 0.0)',
  // arrowsColor: 'rgba(244, 67, 54, 1)',
  numeratio: true,
  overlayClose: true
});
